import apiHelper from '@/services/helper'

const getLearningContentTitle = async () => {
    try {
        let url = '/admin/learning/get-titles'
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getLearningContentWithId = async (param) => {
    try {
        let url = '/admin/learning/get?learning_center_id=' + param
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deleteLearningContentWithId = async (param) => {
    try {
        let url = '/admin/learning/delete?learning_center_id=' + param
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const unDeleteLearningContentWithId = async (param) => {
    try {
        let url = '/admin/learning/undelete?learning_center_id=' + param
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createLearningContent = async (param) => {
    try {
        let url = '/admin/learning/create'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateLearningContent = async (param) => {
    try {
        let url = '/admin/learning/update'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const previewLearningContent = async (param) => {
    try {
        let url = '/admin/learning/preview'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const reorderLearningContent = async (param) => {
    try {
        let url = '/admin/learning/reorder'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getLearningContentTitle,
    getLearningContentWithId,
    deleteLearningContentWithId,
    unDeleteLearningContentWithId,
    createLearningContent,
    updateLearningContent,
    previewLearningContent,
    reorderLearningContent
}
